<template>
	<c-dialog ref="dialog" height="250" width="600" @resolve="editHandle">
		<c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="分类名称" required tip="分类名称不允许重复">
				<c-input name="type_name" maxlength="20"></c-input>
			</c-form-item>
			<c-form-item label="备注">
        <c-input type="textarea" name="remark"></c-input>
			</c-form-item>
    </c-form>
	</c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
	computed: {
	},
	
	data() {
		return {
			  editState: false
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this.editState = !!data;
			this.$refs.form.clear();
			if (data) {
				this.$refs.form.set(data);
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑电子分类' : '添加电子分类'
			});
		},

		/*******添加、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this.editState?'/quotation/type/edit':'/quotation/type/add',
				rule: {
          type_name: '请选输入分类名称',
        },
				dataFormatter: data => {
					return data;
				},
				success: (data, res) => {
					next();
					if(this.editState){
						this.$message({
							message: '编辑成功',  // 提示内容,
							type: 'success'
						});
					}else{
                        this.$message({
                          message: '添加成功',  // 提示内容,
                          type: 'success'
                        });
					}
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>